import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ', ';\n  max-width: ', ';\n  padding: 0 ', ';\n  position: relative;\n'], ['\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ', ';\n  max-width: ', ';\n  padding: 0 ', ';\n  position: relative;\n']);

import styled from 'styled-components';

import { defaultGridColumnWidth, spacing } from './vars';

var getMargin = function getMargin(props) {
  return props.theme.isNestedGrid ? '-' + spacing[props.theme.spacing] + 'px' : 'auto';
};
var getMaxWidth = function getMaxWidth(props) {
  return props.layout === 'fixed' ? defaultGridColumnWidth * props.theme.columns + 'px' : '100%';
};
var getPadding = function getPadding(props) {
  return spacing[props.theme.spacing] / 2 + 'px';
};

var Grid = styled.div(_templateObject, getMargin, getMaxWidth, getPadding);

export default Grid;
export { getMargin, getMaxWidth, getPadding };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/page/dist/esm/internal/GridElement.js
// module id = 562
// module chunks = 0